import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="mt-24"
      style={{ backgroundColor: "var(--jaf-surface)", borderTop: "1px solid var(--jaf-border)" }}
    >
      <div className="jaf-container py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Logo />
            <p
              className="mt-4 max-w-md text-sm leading-relaxed"
              style={{ color: "var(--jaf-text-muted)" }}
            >
              JustAirFry is a cozy corner of the internet for air fryer lovers.
              Real recipes from a real kitchen — tested, tasted, and made for sharing.
            </p>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-3">Explore</h4>
            <ul className="space-y-2 text-sm" style={{ color: "var(--jaf-text-muted)" }}>
              <li><Link data-testid="footer-link-recipes" to="/recipes" className="hover:text-[color:var(--jaf-primary)]">All Recipes</Link></li>
              <li><Link data-testid="footer-link-resources" to="/resources" className="hover:text-[color:var(--jaf-primary)]">Resources</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-[color:var(--jaf-primary)]">About</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-serif text-lg mb-3">Categories</h4>
            <ul className="space-y-2 text-sm" style={{ color: "var(--jaf-text-muted)" }}>
              <li><Link to="/recipes?category=Chicken" className="hover:text-[color:var(--jaf-primary)]">Chicken</Link></li>
              <li><Link to="/recipes?category=Seafood" className="hover:text-[color:var(--jaf-primary)]">Seafood</Link></li>
              <li><Link to="/recipes?category=Snacks" className="hover:text-[color:var(--jaf-primary)]">Snacks</Link></li>
              <li><Link to="/recipes?category=Veggies" className="hover:text-[color:var(--jaf-primary)]">Veggies</Link></li>
              <li><Link to="/recipes?category=Desserts" className="hover:text-[color:var(--jaf-primary)]">Desserts</Link></li>
            </ul>
          </div>
        </div>

        <div className="section-divider my-10" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs" style={{ color: "var(--jaf-text-muted)" }}>
          <p data-testid="footer-copyright">© {new Date().getFullYear()} JustAirFry. All rights reserved.</p>
          <p data-testid="footer-disclaimer" className="max-w-2xl md:text-right">
            JustAirFry is a participant in the Amazon Associates program — an affiliate advertising program designed to provide a means for us to earn fees by linking to Amazon.com.
          </p>
        </div>
      </div>
    </footer>
  );
}
